// Helper function to process video accessibility for a container
function processVideoAccessibility(container, containerName) {
  const lsVideo = container.querySelector('#ls-video');
  
  if (lsVideo && !lsVideo.hasAttribute('aria-labelledby')) {
    lsVideo.setAttribute('aria-labelledby', 'ls-detail-caption');
    
    const lsDetailCaption = document.querySelector('.ls-detail-caption');
    if (lsDetailCaption) {
      lsDetailCaption.setAttribute('id', 'ls-detail-caption');
    }
  }
}

// Function to handle accessibility attributes
function handleLsVideoAccessibility() {
  const containers = [
    { selector: '#ls-slider-popup-container', name: '#ls-slider-popup-container' },
    { selector: '#ls-popup-container', name: '#ls-popup-container' }
  ];
  
  containers.forEach(({ selector, name }) => {
    const container = document.querySelector(selector);
    if (container) {
      processVideoAccessibility(container, name);
    }
  });
}

// Watch for #ls-slider-popup-container
const lsSliderObserver = new MutationObserver((mutations) => {
  handleLsVideoAccessibility();
});

lsSliderObserver.observe(document.body, {
  childList: true,
  subtree: true
});


